<template>
    <div class=date-image-slideshow>
        <Slideshow v-if="loaded" :slides="slides" :settings="slideshowSettings" :hasPopup="true" />

        <PageDescription :post="post" />
    </div>
</template>
<script>

import Slideshow       from '../components/Slideshow.vue'
import PageDescription from '../components/PageDescription.vue'

import moment from 'moment';

export default {
    name : 'DateImageSlideshow',
    props : {
        post : Object,
    },
    components : {
        Slideshow,
        PageDescription,
    },
    data() {
        return {
            slides : []   ,
            loaded : false,
            slideshowSettings : {
                lazy                  : true,
                watchSlidesVisibility : true,
                initialSlide          : 0   ,
            },
        }
    },
    methods : {
        getMoment( dateString, format ) {
            return moment( dateString, format );
        },
        getNow() {
            return moment();
        }
    },
    created() {
        let images = this.post.acf.image_bucket;
        let sortedImages = [];
        let today = this.getNow();

        for( let i in images ) {
            let imageURL = images[i].url.split('/');

            // The file names should begin with a string of numbers which will be the date...hopefully.
            let imageDayMonth = imageURL[imageURL.length-1].replace('.jpg', '').split('-')[0].substring(0, 4);
            
            sortedImages.push({
                image : images[i].url          ,
                title : images[i].caption || '',
                date  : this.getMoment( imageDayMonth, "DDMM" ).format('X'),
            });

        }

        sortedImages.sort( function( a, b ) {
            return a.date - b.date;
        });

        let startSlide = false;
        let diff = 366;

        for( let i in sortedImages ) {
            let imageDate = this.getMoment(sortedImages[i].date, "X");
            let thisDatesDiff = Math.abs( today.diff(imageDate, 'days') );

            if( thisDatesDiff < diff ) {
                startSlide = i;
                diff = thisDatesDiff;
            }

            this.slides.push(sortedImages[i]);

        }

        this.slideshowSettings.initialSlide = ( startSlide || 0 );

        this.loaded = true;
    }
}
</script>